import { render, staticRenderFns } from "./StatementsReportsNeopag.vue?vue&type=template&id=d5b4d616&"
import script from "./StatementsReportsNeopag.vue?vue&type=script&lang=js&"
export * from "./StatementsReportsNeopag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports